import type { AuthAdapter } from '@/app/_auth/auth-adapter'
import { FirebaseAuthAdapter } from '@/app/_auth/firebase-auth'
import { KeycloakAuthAdapter } from '@/app/_auth/keycloak-auth'

// Determine which auth provider to use based on environment variable
const authProvider =
  import.meta.env.VITE_AUTH_PROVIDER ||
  (import.meta.env.VITE_ENVIRONMENT === 'vpc' ? 'keycloak' : 'firebase')

// Create adapter instance (singleton)
const authAdapter: AuthAdapter =
  authProvider === 'keycloak' ? new KeycloakAuthAdapter() : new FirebaseAuthAdapter()

// Initialize adapter (fire and forget, errors are logged)
authAdapter.initialize().catch((err) => {
  console.error(`Failed to initialize ${authProvider}:`, err)
})

export { authAdapter }

// Export auth for backward compatibility (Firebase-specific, lazy-loaded)
export const auth = (() => {
  if (authAdapter instanceof FirebaseAuthAdapter) {
    return authAdapter.getAuth()
  }
  return null
})()
